
export default {
    props: {
        id: {
            type: String,
            default: '',
        },
        bg: {
            type: String,
            default: '',
        },
        region: {
            type: String,
            default: 'uk',
        },
        cpd: {
            type:String,
            default:'member',
        }
    },
    data(){
        return{
            isVisible:false,
            recognised: this.region === 'uk' ? 'recognised' : 'recognized'
        }
    },
    methods:{
        visibilityChanged(isVisible, entry) {
            this.isVisible = isVisible
            console.log(isVisible, entry)
        }
    }
}
